import { render, staticRenderFns } from "./MealCompanionUserSelectField.vue?vue&type=template&id=46fba1be&scoped=true"
import script from "./MealCompanionUserSelectField.vue?vue&type=script&lang=js"
export * from "./MealCompanionUserSelectField.vue?vue&type=script&lang=js"
import style0 from "./MealCompanionUserSelectField.vue?vue&type=style&index=0&id=46fba1be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fba1be",
  null
  
)

export default component.exports